export const RH = 'RH';
export const SA = 'SA';
export const INT = 'INT';
export const SS = 'SS';
export const IS = 'IS';
export const AJGJ = 'AJGJ'
export const SC = 'SC';
export const PM1 = 'PM1';
export const SSC = 'SSC';
export const LD = 'LD';
export const TM = 'TM';
export const PM2 = 'PM2';
export const BB1 = 'BB1';
export const BB2 = 'BB2';

export const selectRH = () => {
    return {
        type: RH,
        payload: true
    };
}

export const removeRH = () => {
    return {
        type: RH,
        payload: false
    };
}

export const selectSA = () => {
    return {
        type: SA,
        payload: true,
    };
}

export const removeSA = () => {
    return {
        type: SA,
        payload: false,
    };
}

export const selectINT = () => {
    return {
        type: INT,
        payload: true,
    };
}

export const removeINT = () => {
    return {
        type: INT,
        payload: false,
    };
}

export const selectSS = () => {
    return {
        type: SS,
        payload: true,
    };
}

export const removeSS = () => {
    return {
        type: SS,
        payload: false,
    };
}

export const selectIS = () => {
    return {
        type: IS,
        payload: true,
    };
}

export const removeIS = () => {
    return {
        type: IS,
        payload: false,
    };
}

export const selectAJGJ = () => {
    return {
        type: AJGJ,
        payload: true,
    };
}

export const removeAJGJ = () => {
    return {
        type: AJGJ,
        payload: false,
    };
}

export const selectSC = () => {
    return {
        type: SC,
        payload: true,
    };
}

export const removeSC = () => {
    return {
        type: SC,
        payload: false,
    };
}

export const selectPM1 = () => {
    return {
        type: PM1,
        payload: true,
    };
}

export const removePM1 = () => {
    return {
        type: PM1,
        payload: false,
    };
}

export const selectSSC = () => {
    return {
        type: SSC,
        payload: true,
    };
}

export const removeSSC = () => {
    return {
        type: SSC,
        payload: false,
    };
}

export const selectLD = () => {
    return {
        type: LD,
        payload: true,
    };
}

export const removeLD = () => {
    return {
        type: LD,
        payload: false,
    };
}

export const selectTM = () => {
    return {
        type: TM,
        payload: true,
    };
}

export const removeTM = () => {
    return {
        type: TM,
        payload: false,
    };
}

export const selectPM2 = () => {
    return {
        type: PM2,
        payload: true,
    };
}

export const removePM2 = () => {
    return {
        type: PM2,
        payload: false,
    };
}

export const selectBB1 = () => {
    return {
        type: BB1,
        payload: true,
    };
}

export const removeBB1 = () => {
    return {
        type: BB1,
        payload: false,
    };
}

export const selectBB2 = () => {
    return {
        type: BB2,
        payload: true,
    };
}

export const removeBB2 = () => {
    return {
        type: BB2,
        payload: false,
    };
}


// WEBPACK FOOTER //
// ./src/actions/selectBrachialPlexusMuscle.js